export default {"src":"https://static.smartdeer.com/global/mkt/_next/static/media/education.a342d61e.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};